/*
 * File: ProductsSelectionStep.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 May 2021 1:40:29 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { ProductsNavigation } from 'components/molecules/ProductsNavigation';
import { ProductsTable } from './ProductsTable';

export const ProductsSelectionStep = (): JSX.Element => {
  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <ProductsNavigation />
      <ProductsTable />
      {/* <Outlet /> */}
    </Space>
  );
};
